import LocalizationContext from 'shared/contexts/LocalizationContext'
import { FC, ReactNode, useState } from 'react'
import get from 'lodash/get'

type Props = {
  children: ReactNode
}

const LocalizationContextDataProvider: FC<Props> = ({ children }) => {
  const [localization, setLocalization] = useState<
    Record<string, Record<string, string>>
  >({})

  const getString = (key: string, locale: string) => {
    const defaultValue = get(localization, [key, 'en'], key)
    return get(localization, [key, locale], defaultValue)
  }

  return (
    <LocalizationContext.Provider value={{ getString, setLocalization }}>
      {children}
    </LocalizationContext.Provider>
  )
}

export default LocalizationContextDataProvider
